module.exports = __webpack_public_path__ + "img/media.1a5b6372.svg";